/**
 * Confirmación de "Cancelar solicitud" de una justificación (008 · T111; contracts/ui.md §2.2,
 * mismo patrón que `regularization/cancel-sheet.tsx`).
 *
 * Explica la consecuencia real antes de confirmar: cancelar cuenta para el tope de
 * `JUSTIFICATION_MAX_PER_DAY_KIND` por día y tipo. Mientras se cancela, la hoja no se puede
 * descartar; un error de red se muestra dentro (se puede reintentar).
 */
import { JUSTIFICATION_MAX_PER_DAY_KIND } from '@fermin/contracts';

import { Button } from '../../components/ui/button';
import { Sheet } from '../../components/ui/sheet';
import { t } from '../../i18n';

export interface JustificationCancelSheetProps {
  open: boolean;
  pending: boolean;
  error: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

export function JustificationCancelSheet({
  open,
  pending,
  error,
  onConfirm,
  onClose,
}: JustificationCancelSheetProps) {
  return (
    <Sheet
      open={open}
      onClose={onClose}
      dismissible={!pending}
      title={t('justification.cancelSheet.title')}
      description={t('justification.cancelSheet.description', {
        max: JUSTIFICATION_MAX_PER_DAY_KIND,
      })}
      className="pb-fm-4"
      footer={
        <div data-testid="justification-cancel-sheet" className="flex flex-col gap-fm-3">
          {error !== null ? (
            <p
              data-testid="justification-cancel-error"
              role="alert"
              className="text-fm-base text-fm-danger-text"
            >
              {error}
            </p>
          ) : null}
          <Button
            data-testid="justification-cancel-confirm"
            variant="destructive"
            onClick={onConfirm}
            loading={pending}
            loadingText={t('justification.cancelSheet.processing')}
          >
            {t('justification.cancelSheet.confirm')}
          </Button>
          <Button variant="ghost" onClick={onClose} disabled={pending}>
            {t('justification.cancelSheet.back')}
          </Button>
        </div>
      }
    />
  );
}
